let marketpaceServer = '_FFFFFFFFFFFFFF00001689753917693088_';
const RTABLESERVER = '_FFFFFFFFFFFFFF00001713960477110008_';

function extractFromGSheet(clientId,gsheetId,gid) {
    const url = '/NitankNode/System/ServerSide/gsheetextractor';
  
    const payload1 = {
      gsheetId: "1j9eBGEWO2AQJvBdFFzbaR2uDtIkB6L1rgQR9CaYpF_I",
      gid: "1643939285"
    };

    const payload = {
        gsheetId: gsheetId,
        gid: gid
      };
  
    fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    })
    .then(response => {
      if (!response.ok) {
        throw new Error("sync google sheet Server responded with status " + response.status);
      }
      return response.json(); // or .text() if the API returns raw data
    })
    .then(data => {
      console.log("sync google sheet Extracted GSheet Data:", data);
    })
    .catch(error => {
      console.error("sync google sheet Error extracting data:", error);
    });
  }
  
  export {
    extractFromGSheet
  }